import icons from "./app-assets-icons";
import images from "./app-assets-images";
import sounds from "./app-assets-sounds";
import data from "./app-assets-data";

export default {
  data: data,
  icons: icons,
  images: images,
  sounds: sounds,
};
